import { AppointmentPatient } from '@dreryk/egabinet-appointment-frontend-api';

export const getPatientName = (patient: AppointmentPatient): string => {
   const { firstName, lastName, phoneNumber } = patient;

   if (firstName && lastName) {
      return `${firstName.asString()} ${lastName.asString()}`;
   }

   return firstName?.asString() || lastName?.asString() || phoneNumber?.asString() || '';
};
